<script>
	  import {setContext} from "svelte";

    let {id, title, actions = [], message = null, children} = $props()     // action: {id, label, symbol, shown, disabled, func}
    // $inspect(`DIALOG - actions`, actions)

    let thisDialog

    // $state (not $derived), so that children can switch buttons on/off via the 'dialog-actions' context
    const showing = $state(Object.assign({message: message}, Object.fromEntries(actions.map(button => [button.id, button.shown ?? false])), {cancel: true}))
    const cancel = actions.find(act => act.id === 'cancel')

    setContext('dialog-actions', showing)


    function select_action (e) {
		    const actionID = e.target.id.slice(7)
		    const action = actions.find(act => act.id === actionID)   // remove the action- part of the id
        if (!action)  return      // click on the footer itself or on its message
        console.log(`DIALOG - execute ${e.target.id}: `, action, "with", $state.snapshot(showing[actionID]))
        thisDialog.close()
        if (action.func)
			      action.func(showing[actionID])
    }

    function click_outside(e) {
		    if (e.target === thisDialog) {
				    if (cancel.func)
						    cancel.func(e)
            else
		          thisDialog.close()
	      }
    }
</script>

<!------------------------------- HTML ------------------------------------->

<dialog bind:this={thisDialog} id={id} class=dlg onclick={click_outside}>
  <div class="dlg-head">
    <h2>{title}</h2>
    <button class="dlg-close" title="Abbrechen" aria-label="cancel" command="close" commandfor={id}></button>
  </div>

  {@render children?.()}

  <menu class="dlg-foot" onclick={select_action}>
    {#if showing.message}
      <li><p class="message" class:error={showing.message !== message}>{showing.message}</p></li>
    {/if}
    {#each actions as action}
      {#if showing[action.id] && action.id !== 'cancel'}
        <li><button id='action-{action.id}' class="btn-primary btn-primary-circle icon-{action.symbol}" disabled={action.disabled}>{action.label}</button></li>
      {:else if showing[action.id]}
        <li><button id='action-cancel' class="button-secondary">Abbrechen</button></li>
      {/if}
    {/each}
  </menu>

</dialog>


<!------------------------------- STYLE ------------------------------------->

<style lang="sass">
  @use "../colors" as colors

  h2
    margin: 0

</style>